import PropTypes from 'prop-types'
import { sliceStatusPropTypes } from '../slice.types'

/**
 * @typedef {Object} ClientOption
 * @property {number} id
 * @property {string} name
 */

/**
 * @typedef {Object} ClientsState
 * @property {ClientOption[]} options - Lightweight client options for dropdowns
 *
 * @typedef {import('../slice.types').BaseSlice & ClientsState} ClientsSlice
 */

/** @type {ClientsSlice} */
export const initialClientsState = {
  status: 'init',
  errors: [],
  options: []
}

/** @enum {string} */
export const CLIENTS_ACTIONS = {
  SET_CLIENTS_STATUS: 'SET_CLIENTS_STATUS',
  SET_CLIENTS_ERRORS: 'SET_CLIENTS_ERRORS',
  SET_CLIENT_OPTIONS: 'SET_CLIENT_OPTIONS'
}

export const clientOptionPropTypes = PropTypes.shape({
  id: PropTypes.number,
  name: PropTypes.string
})

export const clientsSlicePropTypes = PropTypes.shape({
  status: sliceStatusPropTypes,
  errors: PropTypes.arrayOf(PropTypes.shape({ message: PropTypes.string })),
  options: PropTypes.arrayOf(clientOptionPropTypes)
})

/**
 * @typedef {{ type: CLIENTS_ACTIONS, payload: ClientsSlice['status'] }} ClientsStatusAction
 * @typedef {{ type: CLIENTS_ACTIONS, payload: ClientsSlice['errors'] }} ClientsErrorsAction
 * @typedef {{ type: CLIENTS_ACTIONS, payload: ClientOption[] }} ClientOptionsAction
 *
 * @typedef {ClientsStatusAction | ClientsErrorsAction | ClientOptionsAction} ClientsAction
 */
